import React, {Component} from "react";
import Constants from "../configs/Constants";
import {useTranslation} from 'react-i18next';
import _ from "lodash";
import {isNullOrEmpty} from "../common/Utils";

export function Trans(props) {
    const {t} = useTranslation(props.ns);

    if (props.params) {
        return t(props.name, props.params);
    } else {
        return t(props.name);
    }
}

export default class BaseComponent extends Component {
    menuCode = "";
    pageCurr = 1;
    pageSize = Constants.TABLE.SIZE_PER_PAGE;

    constructor(props, menuCode) {
        super(props);
        this.menuCode = menuCode;
        this.options = {
            sizePerPageList: Constants.TABLE.SIZE_PER_PAGE_LIST,
            sizePerPage: Constants.TABLE.SIZE_PER_PAGE,
            noDataText: this.trans('common.nodata'),
            onPageChange: this.onPageChange.bind(this)
        };
    }

    onPageChange(page, sizePerPage) {
        this.pageCurr = page;
        this.pageSize = sizePerPage;
    }

    trans(name, params) {
        let value;
        if (params) {
            value = this.props.t(name, params);
        } else {
            value = this.props.t(name);
        }
        return value;
    };

    genNoCol = (cell, row, enumObject, index) => {
        return <div>{(this.pageCurr - 1) * this.pageSize + index + 1}</div>;
    };

    onChangeTextField = (name, e) => {
        const filter = e.target.getAttribute("filter");
        if (filter)
            e.target.value = this.formatInput(e.target.value, filter);
        this.onChangeValue(this, name, e.target);
    };
    toInputSpace = (field, e) => {
        if (("" + e.target.value).startsWith(' ', 0)) {
            e.target.value = '';
        } else {
            e.target.value = ("" + e.target.value);
        }
    };
    onChangeNumberField = (name, e) => {
        e.target.value = this.formatInput(e.target.value, "number");
        this.onChangeValue(this, name, e.target);
    };
    onChangeSelect = name => value => {
        this.onChangeValue(this, name, value);
    };

    onChangeSelectMultiple = name => value => {
        let data = [];
        if (value) {
            value.forEach(function (item) {
                data.push(String(item).trim())
            });
        }
        this.onChangeValue(this, name, JSON.stringify(data));
    };

    onChangeNumber = (field, e) => {
        e = ("" + e).replace('-', '').replace(/[A-Za-z-]+/g, '').trim();
        this.onChangeValue(this, field, e);
    };


    onChangeCheckbox = async (name, value) => {
        let val = '';
        let isCheck = value.target.checked;
        if (isCheck === true) {
            val = '1';
        } else {
            val = '0';
        }
        await this.onChangeValue(this, name, val);
    };

    async onChangeValue(context, name, value) {
        let realValue = "";
        if (value === undefined || value === null || value === "") {
            return;
        }
        if (typeof value.value === "undefined") {
            if (value === 'null') {
                realValue = "";
            } else {
                realValue = value;
            }
        } else {
            realValue = value.value;
        }

        await context.setState(prevState => ({
            data: {
                ...prevState.data,
                [name]: realValue
            },
            errors: {
                ...prevState.errors,
                [name]: ""
            }
        }));
        if (context.props.options) {
            context.props.options.dataNew = context.state.data;
        }
    }

    onChangeDate = async (name, value) => {
        if (value === undefined || value === "") {
            value = null;
        }
        await this.setState(prevState => ({
            data: {
                ...prevState.data,
                [name]: value
            },
            errors: {
                ...prevState.errors,
                [name]: ""
            }
        }));
        if (this.props.options) {
            this.props.options.dataNew = this.state.data;
        }
    }

    onChangeNestedObject = async (name, child, value) => {
        let realValue = value;
        if(!isNullOrEmpty(value) && typeof value === 'object'){
            realValue = _.get(value, 'target.value', '');
        }
        // console.log(name, child, value, realValue);
        if (value === 'null') {
            realValue = "";
        }
        let object = this.state.data[name] || {};
        object[child] = realValue;
        await this.onChangeValue(this, name, object)
    };

    focusFirstElement = (id) => {
        const form = document.getElementById(id);
        if (!form || !form.elements)
            return false;
        const elements = form.elements;
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].type !== 'hidden' && !elements[i].disabled) {
                elements[i].focus();
                break;
            }
        }
    };

    focusInvalidInput = (errors) => {
        const id = Object.keys(errors)[0];
        const element = document.getElementById(id);
        if (element) {
            if (element.tabIndex === -1) {
                this.focusEl(element);
            } else {
                element.focus();
            }
        }
    };

}
